/*
 * Deburr a string, removing umlauts, accents, etc.
 * IMPORTANT: This does not handle all special characters, only ones that can be decomposed to
 * basic latin characters plus a modifier. For example, ßenchling will remain unchanged.
 *
 *
 * @param {string} str - The string to deburr.
 * @returns {string} The deburred string.
 * @example
 * deburrString('Ärgerlich'); // 'Argerlich'
 */
export default function deburrString(str: string): string {
  return str.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
}
